import React from 'react';
import ReactDOM from 'react-dom';
import '../../styles/profile/CouponCard.scss';

const SummaryPopup = ({ children, onOverlayClick }) => {
  return ReactDOM.createPortal(
    <>
      <div className='summary-popup-overlay' onClick={onOverlayClick} role='button' tabIndex={0} />
      <div>{children}</div>
    </>,
    document.body,
  );
};

export default SummaryPopup;
